export default
[
    {
        "id": 1,
        "apiVersion": "Version 3.1",
        "startDate": new Date(2019,9, 31),
        "endDate": new Date(2019,10, 30),
        "toastMessage": {
            "title": "Alerting settings in API version 3.1",
            "body": "Get teams and contacts and use them when setting up alerting for checks. Read more [in this section](#tag/Teams)"
        }
    },
    {
        "id": 2,
        "apiVersion": "Version 3.1",
        "startDate": new Date(2020, 1, 17), // Start showing now from day of GA
        "endDate": new Date(2020, 2, 30), // We can stop showing it at the end of March.
        "toastMessage": {
            "title": "Manage TMS checks in API v3.1",
            "body": "We now have CRUD endpoints for TMS checks available in the API. Read more [in this section](#tag/TMS-Checks)."
        }
    }
]
